module.exports = __webpack_public_path__ + "img/peel_4.e3e20a11.jpg";